<template>
    <div class="doc-section">
        <h1>Cerrar sesiones de usuarios</h1>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />
        <p>
            En la tabla de usuarios, hacer clic sobre el botón de cerrar sesión, el sistema mostrará una ventana
            emergente con el mensaje “¿Está seguro que desea cerrar la sesión del usuario: nombre_usuario ?” hacer clic
            en el botón “Aceptar” para cerrar la sesión del usuario o en “Cancelar” para no cerrar la sesión del
            usuario.
        </p>

        <div class="info-card">
            <p>
                <strong>Nota: </strong>
                Al aceptar el cierre de sesión del usuario, en todos los dispositivos se cerrara esa sesión iniciada.
            </p>
        </div>

        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesCerrarSesiones" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesCerrarSesionesMoviles" />
        </div>
    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'CerrarSesionesUsuario',
    components: { CarruselAciqui,plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesCerrarSesiones: [
            {
                nombre: "Cierre de sesion de usuario",
                url: "img/usuarios/cerrarSesion.png",
                descripcion: ""
            },
        ],
        imagenesCerrarSesionesMoviles: [
            {
                nombre: "Cierre de sesion de usuario",
                url: "img/usuarios/moviles/cerrarSesion.png",
                descripcion: ""
            },
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>